import React from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import { Table } from 'semantic-ui-react';
import {
  columnDescription,
  columnNameLink,
  columnPublisher,
  columnSelect,
  columnVisibility,
} from '@/constants/fields';
import urls, { codeUrl } from '@/constants/urls';
import TableWrapper from '@/components/table/TableWrapper';
import NoRowsWithPagination from '@/components/table/NoRowsWithPagination';
import { fitToPage, goToCodePage } from '@/hooks/paging';
import DatasetsTableHeader from '@/datasets/components/DatasetsTableHeader';
import DatasetsTableRows from '@/datasets/components/DatasetsTableRows';
import RequestDatasetsFilters from './RequestDatasetsFilters';
import RequestDatasetsContainer, {
  mapStateToProps,
  mapDispatchToProps,
} from '../components/RequestDatasetsContainer';

const RequestDatasetsTable = ({
  canCreate,
  category,
  code,
  columns = [
    columnSelect,
    columnNameLink,
    columnDescription,
    columnVisibility,
    columnPublisher,
  ],
  className,
  currentPage,
  datasets,
  fetchData,
  newDatasetCode,
  onCheckBoxClick,
  pageCount,
  pageSize,
  readErrors,
  readStatus,
  total,
  theme,
}) => {
  const { items, pageNumber } = fitToPage(datasets, currentPage, pageSize);
  const ref = React.useRef(null);

  return (
    <RequestDatasetsContainer category={category} code={code} readStatus={readStatus} fetchData={fetchData}>
      <div className={clsx('ReactTable aridhia-select-datasets', className)} ref={ref}>
        <TableWrapper sticky celled className="aridhia-datasets-table" columns={columns} selectable>
          <DatasetsTableHeader
            columns={columns}
            datasets={items}
            readErrors={readErrors}
            readStatus={readStatus}
          >
            <RequestDatasetsFilters category={category} code={code} className="aridhia-table-filter" />
          </DatasetsTableHeader>
          <Table.Body>
            <DatasetsTableRows
              items={items}
              columns={columns}
              onCheckBoxClick={(value) => onCheckBoxClick(category, code, value)}
              theme={theme}
              selectable
            />
          </Table.Body>
        </TableWrapper>
        <NoRowsWithPagination
          canCreate={canCreate}
          currentPage={pageNumber}
          entity="dataset"
          goToPage={({ page }) => goToCodePage(fetchData, category, code, page, ref)}
          icon="table"
          items={items}
          pageCount={pageCount}
          readErrors={readErrors}
          readStatus={readStatus}
          total={total}
          url={codeUrl(urls.DATASET, newDatasetCode, '#')}
        />
      </div>
    </RequestDatasetsContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(RequestDatasetsTable);
